// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormText, Row, Col, Popover, ButtonGroup, PopoverHeader, PopoverBody } from 'reactstrap';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';
import { compose, checkForm, setIn } from '../common/utils';
import styled from '../common/styled';

const {
  Text, Image, View
} = styled.plain;

const checks = [
  {
    related: ['ctaText'],
    check: (s) => s && s.length,
    errMsg: () => 'CTA Text Required'
  },
];

const checkFormData = checkForm(checks);

class CopyForm extends React.Component {
  state = {
    errMsg: null,
    isSubmitting: false,
    attrs: {
      categories: true,
      subcategories: true,
      tags: true,
      photoAlt: true,
    }
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
  }

  onChangeField = (key, val) => {
    this.setState(setIn(['attrs', key], val, this.state));
  }

  render() {
    return (

      <Modal
        isOpen={this.props.visible}
        className="photoModal"
        onClosed={this.props.onClose}
        size="sm"
      >
        <ModalHeader>Attributes to copy</ModalHeader>
        <ModalBody>

          <Form className="photo-form">
            <div className="form-field">
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label style={{ width: '98px', marginRight: '10px' }} >Categories</Label>
                    <ButtonGroup>
                      <Button outline={!this.state.attrs.categories} onClick={() => this.onChangeField('categories', true)}>Yes</Button>
                      <Button outline={this.state.attrs.categories} onClick={() => this.onChangeField('categories', false)}>No</Button>
                    </ButtonGroup>
                  </FormGroup>
                  <FormGroup>
                    <Label style={{ width: '98px', marginRight: '10px' }} >Subcategories</Label>
                    <ButtonGroup>
                      <Button outline={!this.state.attrs.subcategories} onClick={() => this.onChangeField('subcategories', true)}>Yes</Button>
                      <Button outline={this.state.attrs.subcategories} onClick={() => this.onChangeField('subcategories', false)}>No</Button>
                    </ButtonGroup>
                  </FormGroup>
                  <FormGroup>
                    <Label style={{ width: '98px', marginRight: '10px' }} >Tags</Label>
                    <ButtonGroup>
                      <Button outline={!this.state.attrs.tags} onClick={() => this.onChangeField('tags', true)}>Yes</Button>
                      <Button outline={this.state.attrs.tags} onClick={() => this.onChangeField('tags', false)}>No</Button>
                    </ButtonGroup>
                  </FormGroup>
                  <FormGroup>
                    <Label style={{ width: '98px', marginRight: '10px' }} >Photo Alt</Label>
                    <ButtonGroup>
                      <Button outline={!this.state.attrs.photoAlt} onClick={() => this.onChangeField('photoAlt', true)}>Yes</Button>
                      <Button outline={this.state.attrs.photoAlt} onClick={() => this.onChangeField('photoAlt', false)}>No</Button>
                    </ButtonGroup>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </Form >

        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={this.props.onClose}>Cancel</Button>
          <Button color="primary" outline onClick={() => this.props.onDone(this.state.attrs)}>Copy</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

CopyForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
};

export default compose(
  connect(
    state => ({
      settings: state.settings.detail,
    }),
    dispatch => bindActionCreators({ ...actions }, dispatch)
  ),
  withRouter
)(CopyForm);
